import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EvkSeccionModel } from '../../expediente/models/evk-seccion.model';

@Injectable({
    providedIn: 'root'
})
export class DataWizardService {

    // Elementos de la botonera
    private $botonSiguiente: Subject<boolean> = new Subject<boolean>();
    private destroy$ = new Subject();
    public botonSiguiente: Observable<boolean> = this.$botonSiguiente.asObservable().pipe(takeUntil(this.destroy$));

    // Elementos de los datos del expediente
    // todo cambiar any por su respectivo objeto
    private $dataWizard: BehaviorSubject<any> = new BehaviorSubject<any>({});
    public dataWizard: Observable<any> = this.$dataWizard.asObservable().pipe(takeUntil(this.destroy$));
    private $dataFolio: Subject<String> = new Subject<String>();
    public dataFolio: Observable<any> = this.$dataFolio.asObservable();

    private $dataSeccion: BehaviorSubject<EvkSeccionModel[]> = new BehaviorSubject<EvkSeccionModel[]>(undefined);
    public dataSeccion: Observable<EvkSeccionModel[]> = this.$dataSeccion.asObservable().pipe(takeUntil(this.destroy$));

    constructor() { }

    // Metodos boton
    public cambiarBotonSiguiente(input: boolean) {
        this.$botonSiguiente.next(input);
    }

    //Metodos data expediente.
    public setDataWizard(data: any) {
        this.$dataWizard.next(data);
    }

    public setDataFolio(data: any) {
        this.$dataFolio.next(data);
    }

    public stopSubscriptions() {
        this.destroy$.next();
    }
}
